import { render } from "./CommerceSalesShow.vue?vue&type=template&id=db68a592&scoped=true"
import script from "./CommerceSalesShow.vue?vue&type=script&lang=js"
export * from "./CommerceSalesShow.vue?vue&type=script&lang=js"

import "./CommerceSalesShow.vue?vue&type=style&index=0&id=db68a592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db68a592"]])

export default __exports__